import { BannerAction } from '../ActionApi/UserActionRequestModel';
import { API_V2 } from '../api';
import { EventBannerReportData } from './EventDataModel';

export interface EventBannerDataRequest {
	action: BannerAction;
	fromDate: Date;
	toDate: Date;
}

export function fetchEventBannerData(eventId: string, params: EventBannerDataRequest): Promise<EventBannerReportData[]> {
	return API_V2.get(`/event/${eventId}/data/banner`, { params })
		.then(({ data }) => data as EventBannerReportData[]);
}
